module.exports = __webpack_public_path__ + "static/box-d6ad3aacadf469bb71d429f4dd32ac86.png";